<template>
  <div>
    <div
      id="layout"
      style="visibility: visible;"
    >
      <div
        id="north"
        class="north"
      >
        <header-info cur="2"></header-info>
      </div>
      <div
        id="center"
        class="center_box"
      >
        <div
          id="main"
          class="main clearfix"
        >
          <div
            id="leftmenu"
            class="leftmenu"
          >
            <div class="leftmenu-item">
              <p class="p1">成绩接口</p>
              <ul class="leftmenu-list">
                <li
                  class="li1"
                  :class="menuSelected == '/dev/get_ticket' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/dev/get_ticket"><i class="iconfont"></i>获取Ticket
                  </router-link>
                </li>
                <li
                  class="li2"
                  :class="menuSelected == '/dev/data_upload' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/dev/data_upload"><i class="iconfont"></i>实验数据回传
                  </router-link>
                </li>
                <li
                  class="li2"
                  :class="menuSelected == '/dev/report_upload' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/dev/report_upload"><i class="iconfont"></i>实验报告上传
                  </router-link>
                </li>
                <li
                  class="li2"
                  :class="menuSelected == '/dev/ticket_info' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/dev/ticket_info"><i class="iconfont"></i>解析Ticket信息
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="leftmenu-item">
              <p class="p1">第三方登陆</p>
              <ul class="leftmenu-list">
                <li
                  class="li1"
                  :class="menuSelected == '/dev/open_login' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/dev/open_login"><i class="iconfont"></i>登陆接口
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="leftmenu-item">
              <p class="p1">模拟调用数据接口</p>
              <ul class="leftmenu-list">
                <li
                  class="li1"
                  :class="menuSelected == '/dev/experiment_api_test' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/dev/experiment_api_test"><i class="iconfont"></i>模拟调用数据接口
                  </router-link>
                </li>
                <li
                  class="li1"
                  :class="menuSelected == '/dev/experiment_report_test' ? 'on' : ''"
                  @click="updateMenuSelected"
                >
                  <router-link to="/dev/experiment_report_test"><i class="iconfont"></i>模拟实验报告上传接口
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div id="panel-wrap">
            <router-view></router-view>
          </div>
        </div>
      </div>
      <div id="south">
        <footer-info></footer-info>
      </div>
    </div>
  </div>
</template>

<script>

import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'

export default {
  name: 'DevLayout',
  components: {
    HeaderInfo,
    FooterInfo
  },

  data: function () {
    return {
      menuSelected: '',
      showMsgWindow: {},
      msgText: '',
      msgType: 0,
      errorList: []
    }
  },
  methods: {
    updateMenuSelected() {
      const url = window.location.href
      const arrUrl = url.split('//')
      const start = arrUrl[1].indexOf('/')
      let relUrl = arrUrl[1].substring(start)

      if (relUrl.indexOf('?') !== -1) {
        relUrl = relUrl.split('?')[0]
      }
      relUrl = relUrl.replace('#', '')
      this.menuSelected = relUrl
    },
    showMsg(text, callback = '') {
      this.msgType = 0
      this.msgText = text
      this.showMsgWindow = {
        visibility: 'visible'
      }
      this.confirmCallback = callback
    },
    showConfirm(text, callback) {
      this.msgType = 1
      this.msgText = text
      this.showMsgWindow = {
        visibility: 'visible'
      }
      this.confirmCallback = callback
    },
    pushError(err) {
      this.errorList.push(err)
    },
    hideMsg() {
      this.msgText = ''
      this.showMsgWindow = {}
    },
    confirmMsg() {
      this.msgText = ''
      this.showMsgWindow = {}
      if (this.confirmCallback) {
        this.confirmCallback()
        this.confirmCallback = ''
      }
    },
    FunisShow(role) {
      if (role === '') {
        return true
      } else if (parseInt(role) === 1) {
        return true
      } else if (parseInt(role) === 2) {
        return true
      } else if (parseInt(role) === 3) {
        return false
      }
    }
  },
  mounted() {
    this.updateMenuSelected()
  },
  // 计算属性
  computed: {
    localUser() {
      return this.$store.state.userInfo
    }
  }
}
</script>

<style scoped>
@import "../../../assets/css/dialog.css";
@import "../../../assets/css/common.css";

@import "../../../assets/css/pagination.css";
@import "../../../assets/css/form.css";
@import "../../../assets/css/panel.css";

@import "../../../assets/css/leftmenu.css";

.logo {
  background-image: url("../../../assets/images/logo.png");
}
</style>
